(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["color-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.cgReady === 'true') return;
      root.dataset.cgReady = 'true';

      const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
      const dialog = root.querySelector('[data-cg-dialog]');
      const dialogMedia = dialog.querySelector('[data-cg-dialog-media]');
      const dialogCode = dialog.querySelector('[data-cg-dialog-code]');
      const dialogName = dialog.querySelector('[data-cg-dialog-name]');
      const dialogBrief = dialog.querySelector('[data-cg-dialog-brief]');
      const dialogDetails = dialog.querySelector('[data-cg-dialog-details]');
      const dialogBest = dialog.querySelector('[data-cg-dialog-best]');
      let lastTrigger = null;

      const ensureModel = (card) => {
        const slot = card.querySelector('[data-cg-model-slot]');
        if (slot.firstElementChild) return slot.firstElementChild;
        const template = card.querySelector('[data-cg-model-template]');
        if (!template) return null;
        slot.append(template.content.cloneNode(true));
        return slot.firstElementChild;
      };

      const showModel = (card, visible) => {
        if (visible && !ensureModel(card)) return;
        card.classList.toggle('is-model', visible);
        card.querySelector('[data-cg-toggle]').setAttribute('aria-pressed', String(visible));
      };

      root.querySelectorAll('[data-cg-card]').forEach((card) => {
        const toggle = card.querySelector('[data-cg-toggle]');

        toggle.addEventListener('pointerenter', () => {
          if (hoverCapable.matches) showModel(card, true);
        });

        toggle.addEventListener('pointerleave', () => {
          if (card.dataset.locked !== 'true') showModel(card, false);
        });

        toggle.addEventListener('focus', () => showModel(card, true));
        toggle.addEventListener('blur', () => {
          if (card.dataset.locked !== 'true') showModel(card, false);
        });

        toggle.addEventListener('click', () => {
          const willLock = card.dataset.locked !== 'true';
          card.dataset.locked = String(willLock);
          showModel(card, willLock || (hoverCapable.matches && toggle.matches(':hover')));
        });
      });

      const populateDialog = (card) => {
        const source = card.querySelector('[data-cg-source]');
        const image = ensureModel(card) || card.querySelector('.cg-card__swatch');
        dialogCode.textContent = source.querySelector('[data-cg-source-code]').textContent.trim();
        dialogCode.hidden = !dialogCode.textContent;
        dialogName.textContent = source.querySelector('[data-cg-source-name]').textContent.trim();
        dialogBrief.textContent = source.querySelector('[data-cg-source-brief]').textContent.trim();
        dialogDetails.textContent = source.querySelector('[data-cg-source-details]').textContent.trim();
        dialogBest.textContent = source.querySelector('[data-cg-source-best]').textContent.trim();
        dialogMedia.replaceChildren();
        if (image) {
          const clone = image.cloneNode(true);
          clone.removeAttribute('loading');
          dialogMedia.append(clone);
        }
      };

      root.querySelectorAll('[data-cg-details]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          lastTrigger = trigger;
          const openDialog = () => {
            populateDialog(trigger.closest('[data-cg-card]'));
            if (!dialog.open) dialog.showModal();
          };
          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.startViewTransition(openDialog);
          } else {
            openDialog();
          }
        });
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => {
        if (lastTrigger) lastTrigger.focus();
      });

      const links = [...root.querySelectorAll('.cg__nav-link')];
      const groups = [...root.querySelectorAll('[data-cg-group]')];
      const setActive = (category) => {
        links.forEach((link) => link.classList.toggle('is-active', link.hash.endsWith('-' + category)));
      };

      links.forEach((link) => {
        link.addEventListener('click', () => setActive(link.dataset.cgCategory));
      });

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (visible) setActive(visible.target.dataset.category);
      }, { rootMargin: '-22% 0px -62% 0px', threshold: 0 });

      groups.forEach((group) => observer.observe(group));
    };

    document.querySelectorAll('[data-color-guide]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-color-guide]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["privacy-policy-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-privacy-policy]');
    if (!root) return;

    const body = root.querySelector('[data-privacy-body]');
    const toc = root.querySelector('[data-privacy-toc]');
    if (!body || !toc) return;

    const headings = Array.from(body.querySelectorAll('h2, h3'));
    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text || heading.closest('.pp-contact')) return;

      const slug = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const id = heading.id || `privacy-${slug || 'section'}-${index + 1}`;
      heading.id = id;
      heading.classList.add('pp-auto-heading');

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = text;
      item.appendChild(link);
      toc.appendChild(item);
    });

    body.querySelectorAll('p').forEach((paragraph) => {
      const text = paragraph.textContent.toLowerCase();
      if (/cookie|tracking|targeted advertising|sale or sharing/.test(text)) {
        paragraph.classList.add('pp-auto-notice');
      }
      if (/access|correct|delete|opt out|withdraw|privacy rights/.test(text)) {
        paragraph.classList.add('pp-rights-notice');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["return-refund-policy-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-refund-policy]');
    if (!root) return;

    const body = root.querySelector('[data-refund-body]');
    const toc = root.querySelector('[data-refund-toc]');
    if (!body || !toc) return;

    const headings = Array.from(body.querySelectorAll('h2, h3'));
    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text) return;

      const slug = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const id = heading.id || `refund-${slug || 'section'}-${index + 1}`;
      heading.id = id;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = text;
      item.appendChild(link);
      toc.appendChild(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shipping-policy-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-shipping-policy]');
    if (!root) return;

    const body = root.querySelector('[data-shipping-body]');
    const toc = root.querySelector('[data-shipping-toc]');
    if (!body || !toc) return;

    const headings = Array.from(body.querySelectorAll('h2, h3'));
    headings.forEach((heading, index) => {
      const text = heading.textContent.trim();
      if (!text || heading.closest('.sp-contact')) return;

      const slug = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const id = heading.id || `shipping-${slug || 'section'}-${index + 1}`;
      heading.id = id;
      heading.classList.add('sp-auto-heading');

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = text;
      item.appendChild(link);
      toc.appendChild(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terms-of-service-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-terms-policy]');
    if (!root) return;

    const body = root.querySelector('[data-terms-body]');
    const toc = root.querySelector('[data-terms-toc]');
    if (!body || !toc) return;

    const markers = Array.from(body.querySelectorAll('strong')).filter((marker) => {
      return /^(overview|section\s+\d+)/i.test(marker.textContent.trim());
    });

    markers.forEach((marker, index) => {
      const label = marker.textContent.trim();
      const slug = label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      const id = `terms-${slug || 'section'}-${index + 1}`;
      marker.id = id;
      marker.classList.add('ts-section-heading');

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.textContent = label;
      item.appendChild(link);
      toc.appendChild(item);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xuhe-factory-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  const registryKey = '__xuheFactoryProcessControls';
  const existing = window[registryKey];

  if (existing && typeof existing.init === 'function') {
    existing.init(document);
    return;
  }

  const instances = new Map();

  function initialiseTrack(track) {
    if (instances.has(track)) return;

    const shell = track.parentElement;
    const controls = shell && shell.querySelector('[data-xf-process-controls]');
    const cards = Array.from(track.querySelectorAll('.xf-process-flow__item'));
    if (!controls || !cards.length) return;

    const previousButton = controls.querySelector('[data-xf-process-prev]');
    const nextButton = controls.querySelector('[data-xf-process-next]');
    const currentLabel = controls.querySelector('[data-xf-process-current]');
    const totalLabel = controls.querySelector('[data-xf-process-total]');
    const status = controls.querySelector('[data-xf-process-status]');
    if (!previousButton || !nextButton || !currentLabel || !totalLabel || !status) return;

    const originalTabIndex = track.getAttribute('tabindex');
    const originalAriaCurrent = cards.map(function (card) { return card.getAttribute('aria-current'); });
    const originalPreviousDisabled = previousButton.disabled;
    const originalNextDisabled = nextButton.disabled;
    const mobileQuery = window.matchMedia('(max-width: 639px)');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const removers = [];
    let active = false;
    let destroyed = false;
    let targets = [];
    let measuredWidth = 0;
    let currentIndex = 0;
    let pendingIndex = null;
    let scrollFrame = 0;
    let measureFrame = 0;
    let quietTimer = 0;
    let announcedIndex = -1;

    function restoreAttribute(element, name, value) {
      if (value === null) element.removeAttribute(name);
      else element.setAttribute(name, value);
    }

    function listen(element, name, handler, options) {
      element.addEventListener(name, handler, options);
      removers.push(function () { element.removeEventListener(name, handler, options); });
    }

    function listenMedia(query, handler) {
      if (typeof query.addEventListener === 'function') {
        query.addEventListener('change', handler);
        removers.push(function () { query.removeEventListener('change', handler); });
      } else {
        query.addListener(handler);
        removers.push(function () { query.removeListener(handler); });
      }
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(cards.length - 1, index));
    }

    function nearestIndex() {
      let nearest = clampIndex(currentIndex);
      let distance = Infinity;
      targets.forEach(function (target, index) {
        const nextDistance = Math.abs(track.scrollLeft - target);
        if (nextDistance < distance) {
          distance = nextDistance;
          nearest = index;
        }
      });
      return nearest;
    }

    function updateButtons() {
      const navigationIndex = pendingIndex === null ? currentIndex : pendingIndex;
      previousButton.disabled = navigationIndex === 0;
      nextButton.disabled = navigationIndex === cards.length - 1;
    }

    function render(announce) {
      if (!active || destroyed) return;
      currentIndex = nearestIndex();
      currentLabel.textContent = String(currentIndex + 1).padStart(2, '0');
      totalLabel.textContent = String(cards.length).padStart(2, '0');
      cards.forEach(function (card, index) {
        if (index === currentIndex) card.setAttribute('aria-current', 'step');
        else card.removeAttribute('aria-current');
      });
      updateButtons();
      if (announce && announcedIndex !== currentIndex) {
        const template = controls.dataset.xfProcessStatusTemplate;
        if (template) {
          status.textContent = template
            .split('[current]').join(String(currentIndex + 1))
            .split('[total]').join(String(cards.length));
        }
        announcedIndex = currentIndex;
      }
    }

    function queueRender() {
      if (!active || destroyed || scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(function () {
        scrollFrame = 0;
        render(false);
      });
    }

    function finishScroll() {
      window.clearTimeout(quietTimer);
      quietTimer = 0;
      if (!active || destroyed) return;
      pendingIndex = null;
      render(true);
    }

    function scheduleQuietFinish() {
      window.clearTimeout(quietTimer);
      quietTimer = window.setTimeout(finishScroll, 180);
    }

    function onScroll() {
      if (!active) return;
      queueRender();
      scheduleQuietFinish();
    }

    function onScrollEnd() {
      if (!active) return;
      if (pendingIndex !== null && Math.abs(track.scrollLeft - targets[pendingIndex]) > 1.5) {
        scheduleQuietFinish();
        return;
      }
      finishScroll();
    }

    function cancelPending() {
      if (!active || pendingIndex === null) return;
      pendingIndex = null;
      render(false);
    }

    function navigateTo(index) {
      if (!active || destroyed || !targets.length) return;
      pendingIndex = clampIndex(index);
      updateButtons();
      track.scrollTo({ left: targets[pendingIndex], behavior: motionQuery.matches ? 'instant' : 'smooth' });
      queueRender();
      scheduleQuietFinish();
    }

    function navigateBy(direction) {
      const baseIndex = pendingIndex === null ? nearestIndex() : pendingIndex;
      const nextIndex = clampIndex(baseIndex + direction);
      if (nextIndex !== baseIndex) navigateTo(nextIndex);
    }

    function onKeyDown(event) {
      if (!active || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowLeft') navigateBy(-1);
      else if (event.key === 'ArrowRight') navigateBy(1);
      else if (event.key === 'Home') navigateTo(0);
      else if (event.key === 'End') navigateTo(cards.length - 1);
      else return;
      event.preventDefault();
    }

    function measure(force) {
      if (!active || destroyed) return;
      const preservedIndex = clampIndex(currentIndex);
      const trackBounds = track.getBoundingClientRect();
      const viewportStart = trackBounds.left + track.clientLeft;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const measuredTargets = cards.map(function (card) {
        const bounds = card.getBoundingClientRect();
        const target = track.scrollLeft + bounds.left - viewportStart;
        return Math.max(0, Math.min(maxScroll, target));
      });
      const changed = Math.abs(track.clientWidth - measuredWidth) > 0.5 || measuredTargets.length !== targets.length || measuredTargets.some(function (target, index) {
        return Math.abs(target - targets[index]) > 0.5;
      });
      targets = measuredTargets;
      measuredWidth = track.clientWidth;
      if (force || changed) {
        pendingIndex = null;
        window.clearTimeout(quietTimer);
        quietTimer = 0;
        track.scrollTo({ left: targets[preservedIndex], behavior: 'instant' });
      }
      render(true);
    }

    function queueMeasure() {
      if (!active || destroyed || measureFrame) return;
      measureFrame = window.requestAnimationFrame(function () {
        measureFrame = 0;
        measure(false);
      });
    }

    function clearScheduledWork() {
      window.cancelAnimationFrame(scrollFrame);
      window.cancelAnimationFrame(measureFrame);
      window.clearTimeout(quietTimer);
      scrollFrame = 0;
      measureFrame = 0;
      quietTimer = 0;
      pendingIndex = null;
    }

    function restoreWideState() {
      restoreAttribute(track, 'tabindex', originalTabIndex);
      cards.forEach(function (card, index) {
        restoreAttribute(card, 'aria-current', originalAriaCurrent[index]);
      });
      previousButton.disabled = originalPreviousDisabled;
      nextButton.disabled = originalNextDisabled;
      controls.hidden = true;
    }

    function setActive() {
      if (destroyed) return;
      active = mobileQuery.matches;
      clearScheduledWork();
      if (active) {
        track.setAttribute('tabindex', '0');
        controls.hidden = false;
        measure(true);
      } else {
        restoreWideState();
      }
    }

    function onMotionChange() {
      if (!active || !motionQuery.matches || pendingIndex === null) return;
      track.scrollTo({ left: targets[pendingIndex], behavior: 'instant' });
      finishScroll();
    }

    let observer = null;
    if (typeof window.ResizeObserver === 'function') {
      observer = new window.ResizeObserver(queueMeasure);
      observer.observe(track);
      cards.forEach(function (card) { observer.observe(card); });
    }

    listen(previousButton, 'click', function () { navigateBy(-1); });
    listen(nextButton, 'click', function () { navigateBy(1); });
    listen(track, 'scroll', onScroll, { passive: true });
    listen(track, 'scrollend', onScrollEnd);
    listen(track, 'pointerdown', cancelPending, { passive: true });
    listen(track, 'touchstart', cancelPending, { passive: true });
    listen(track, 'wheel', cancelPending, { passive: true });
    listen(track, 'keydown', onKeyDown);
    listen(window, 'resize', queueMeasure, { passive: true });
    listenMedia(mobileQuery, setActive);
    listenMedia(motionQuery, onMotionChange);

    instances.set(track, {
      destroy: function () {
        if (destroyed) return;
        destroyed = true;
        active = false;
        clearScheduledWork();
        if (observer) observer.disconnect();
        removers.forEach(function (remove) { remove(); });
        restoreWideState();
        instances.delete(track);
      }
    });

    setActive();
  }

  function init(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    if (root === document && document.readyState === 'loading') return;
    if (typeof root.matches === 'function' && root.matches('[data-xf-process-flow]')) initialiseTrack(root);
    root.querySelectorAll('[data-xf-process-flow]').forEach(initialiseTrack);
  }

  function unload(root) {
    if (!root || typeof root.contains !== 'function') return;
    Array.from(instances.entries()).forEach(function (entry) {
      if (root === entry[0] || root.contains(entry[0])) entry[1].destroy();
    });
  }

  window[registryKey] = { init: init };
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unload(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
